export const COMMIT_SHA = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
export const DEPLOYMENT_URL = process.env.NEXT_PUBLIC_VERCEL_URL;
export const IDV_SESSION_RETRY_LIMIT = 2;

export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV;

export const APPCLIP_URL = 'https://appclip.apple.com/id?p=com.onefootprint.my.Clip';
